module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "abbrs"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pviii"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pix"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiheggie0006#toc"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "border-bottom": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AMEE")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("American Mount Everest Expedition (1963)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AMREE")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("American Medical Research Expedition to Everest (1981)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AMS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("acute mountain sickness")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BAS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("British Antarctic Survey")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("DIPAS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("(India) Defense Institute of Physiology and Allied Sciences")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ECG")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("electrocardiogram")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("EPO")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("erythropoietin")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("FIDS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Falkland Islands Dependencies Survey (later BAS)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("IBEA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("International Biomedical Expedition to the Antarctic (1980–81)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("IBP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("International Biological Program (1964–74)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ICAO")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("International Civil Aviation Organization")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("IGY")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("International Geophysical Year (1957–58)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("IMP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("integrating motor pneumotachograph")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("INPHEXAN")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("International Physiological Expedition to Antarctica (1957)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("IOC")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("International Olympic Committee")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("MRC")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Medical Research Council")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NIMR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("(UK) National Institute of Medical Research")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("OEI, II, III")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Operation Everest")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ONR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("(US) Office for Naval Research")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "data-locator": "p1"
    }
  }), _c('span', {
    staticClass: "gt"
  }, [_vm._v("P"), _c('sub', [_vm._v("O")]), _vm._v("₂, P"), _c('sub', [_vm._v("CO")]), _vm._v("₂")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("partial pressure of oxygen, carbon dioxide")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("RAF")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("(UK) Royal Air Force")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("RGS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("(UK) Royal Geographical Society")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SCAR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Scientific Committee on Antarctic Research")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("TAE")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Commonwealth Trans-Antarctic Expedition (1955–58)")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31553a2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-heggie-0007.vue
// module id = 72
// module chunks = 0